import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { ratioFormSchema } from './ratio-form-schema.js';
export const productUomConversionEditFormSchema = z.object({
    stateId: optionalUuidString('Invalid state selection.'),
    uomId: requiredUuidString('UOM is required.', 'Invalid UOM selection.'),
    ratio: ratioFormSchema,
});
//# sourceMappingURL=update-form.js.map